//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});



$(document).ready(function(){


  //Product Slideswhow
  const productSwiper = new Swiper('.product_images_mobile.with-swiper .swiper-container', {
    loop: true,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    }
  });

  //Cart Drawer
  $('.toggle_cart').click(function(e){
    e.preventDefault();
    $('#side_cart, #cart_mask,#cart_suggestions').toggleClass('open');
    $('body').removeClass('search_open');
    $('body').removeClass('menu_open');
  });

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count, .cart_count').html(cart.item_count);
        } );
      }
    });
  });

  //Wrap Blog/Page videos in class
  $(".page_wrap.article_content iframe").wrap("<div class='article_video'/>");

  //Wrap Big Tables in wrapper on pages like Truck Size Guide
  $('.page_content table').wrap("<div class='table_wrap'></div>");

  //Toggle Socials
  $('.toggle_socials').click(function(e){
    $('body').toggleClass('socials_open');
  });

  //Toggle Privacy
  $('.toggle_privacy').click(function(e){
    $('body').toggleClass('privacy_open');
  });

  //Toggle Copyright
  $('.toggle_copyright').click(function(e){
    $('body').toggleClass('copyright_open');
  });

  
});